/* MASONTEX · Product template guard · compatibility/accessibility only */
(() => {
  'use strict';

  let lastTrigger = null;
  let restoreTimer = null;
  const modal = () => document.getElementById('V12OemRequest');
  const isOpen = (node) => Boolean(node && !node.hidden && node.classList.contains('is-open'));
  const dialog = (node) => node?.querySelector('.msq-inquiry__dialog');
  const focusables = (node) => [...(node?.querySelectorAll('a[href],button:not([disabled]),input:not([type="hidden"]):not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])') || [])]
    .filter((el) => !el.hidden && el.getAttribute('aria-hidden') !== 'true' && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));

  function focusIntoModal(node) {
    const box = dialog(node);
    if (!box) return;
    const feedback = box.querySelector('[data-msq-modal-feedback]');
    const preferred = feedback || box.querySelector('input:not([type="hidden"]):not([disabled]),select:not([disabled]),textarea:not([disabled]),button:not([disabled])');
    preferred?.focus({ preventScroll: true });
  }

  function restoreFocus() {
    clearTimeout(restoreTimer);
    restoreTimer = setTimeout(() => {
      if (lastTrigger && document.contains(lastTrigger) && typeof lastTrigger.focus === 'function') lastTrigger.focus({ preventScroll: true });
      lastTrigger = null;
    }, 240);
  }

  document.addEventListener('click', (event) => {
    const modalTrigger = event.target.closest('[data-msq-modal-trigger]');
    if (modalTrigger) {
      lastTrigger = modalTrigger;
      const builderCta = document.querySelector('[data-ms-quick-oem] [data-msq-cta]');
      if (builderCta) {
        event.preventDefault();
        event.stopImmediatePropagation();
        builderCta.click();
        return;
      }
    }
    const trigger = event.target.closest('[data-msq-cta],a[href="#V12OemRequest"]');
    if (trigger) lastTrigger = trigger;
  }, true);

  document.addEventListener('keydown', (event) => {
    const node = modal();
    if (!isOpen(node) || event.key !== 'Tab') return;
    const box = dialog(node);
    const items = focusables(box);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    const active = document.activeElement;
    if (event.shiftKey && (active === first || !box.contains(active))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  });

  function watch() {
    const node = modal();
    if (!node || node.dataset.msTemplateGuard === '1') return;
    node.dataset.msTemplateGuard = '1';
    let wasOpen = isOpen(node);
    const sync = () => {
      const open = isOpen(node);
      if (open && !wasOpen) setTimeout(() => focusIntoModal(node), 110);
      if (!open && wasOpen) restoreFocus();
      wasOpen = open;
    };
    new MutationObserver(sync).observe(node, { attributes: true, attributeFilter: ['class', 'hidden', 'aria-hidden'] });
    sync();
  }

  const boot = () => watch();

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', () => setTimeout(boot, 0));
})();
